module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "my_scroller",
    staticClass: "scrolls",
    on: {
      "scroll": function($event) {
        return _vm.scroll($event.target)
      }
    }
  }, [_c('div', {
    ref: "my_scroller_box",
    staticClass: "scroll-box",
    style: (_vm.diff ? {
      transform: ("translate3d(0, " + _vm.diff + "px, 0)")
    } : '')
  }, [(_vm.topLoadMethod) ? _c('div', {
    staticClass: "action-block",
    class: {
      'c-black': _vm.colorBlack
    },
    style: ({
      height: (_vm.topBlockHeight + "px"),
      top: ("-" + _vm.topBlockHeight + "px")
    })
  }, [_c('svg', {
    staticClass: "icon",
    class: {
      'icon-arrow': _vm.state === 'trigger',
        'icon-loading': _vm.state === 'loading',
        'c-black': _vm.colorBlack
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconLink
    }
  })]), _vm._v("\n      " + _vm._s(_vm.refreshText) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scroll-container"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.onInfinite) ? _c('div', {
    ref: "load",
    staticClass: "load"
  }, [(_vm.loadingState == 0) ? _c('p', {
    class: {
      'c-black': _vm.colorBlack
    }
  }, [_vm._v(_vm._s(_vm.isData === 3 ? '' : '已经到底啦~'))]) : (_vm.loadingState == 3) ? _c('p', {
    class: {
      'c-black': _vm.colorBlack
    },
    on: {
      "click": function($event) {
        _vm.loadingState = 1;
        _vm.deInit()
      }
    }
  }, [_vm._v("加载失败，点击重试")]) : _c('p', [_c('svg', {
    staticClass: "load-icon",
    class: {
      'c-black': _vm.colorBlack
    },
    attrs: {
      "viewBox": "0 0 64 64"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-loading"
    }
  })]), _vm._v(" "), _c('span', {
    class: {
      'c-black': _vm.colorBlack
    }
  }, [_vm._v("加载中...")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-242453f1"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/scroll.vue
// module id = 146
// module chunks = 19